// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"GS-z","inlineTitle":"HS-z","sponsoredAdsWrapper":"IS-z","marketplaceRecosWrapper":"JS-z"};